<template>
  <div>
    <DownloadScreen
      v-if="downloadOpen"
      :items="downloadItems"
      :closeScreen="
        () => {
          downloadOpen = false;
        }
      "
    />
    <div @click="downloadOpen = true" class="downloadButton-downloads">
      <div class="downloadButton-downloads-text">
        {{ $i18n.t(title) }}
      </div>
      <img
        class="downloadButton-downloads-img"
        :src="require('@/assets/svg/download.svg')"
      />
    </div>
  </div>
</template>

<script>
import DownloadScreen from "@/components/DownloadScreen/DownloadScreen";

export default {
  name: "DownloadButton",
  components: {
    DownloadScreen,
  },
  props: {
    title: String,
    downloadItems: Array,
  },
  data: function() {
    return {
      downloadOpen: false,
    };
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss";
.downloadButton {
  &-downloads {
    text-align: center;
    color: #231f20;
    @include flex-h(center, center);
    margin-top: 32px;
    padding-bottom: 32px;
    cursor: pointer;
    &-text {
      @include ts-fat-wide();
      margin-right: 15px;
      text-transform: uppercase;
    }
    &-img {
      height: 40px;
      @include breakpoint(xs) {
        height: 24px;
      }
      @include breakpoint(s) {
        height: 34px;
      }
    }
  }
}
</style>
